import React, { useLayoutEffect } from 'react';
import { Button, Typography } from '@mui/material';

const Redirect = (): React.ReactElement => {
  const close = () => {
    window.close();
  };
  useLayoutEffect(() => {
    if (window.opener) {
      window.opener.postMessage(window.location.href, window.location.origin);
      setTimeout(window.close, 5000);
    } else if (window.parent) {
      window.parent.postMessage(window.location.href, window.location.origin);
    } else {
      console.info('You can close this window');
    }
  }, []);

  return (
    <div>
      <Typography variant="h5" component="h2">
        You can close this window
      </Typography>
      <Button variant="contained" onClick={close}>
        Close
      </Button>
    </div>
  );
};

export default Redirect;
